import React, {useRef, useState} from 'react';
import {Button, Card, Collapse, Divider, Empty, List, Skeleton, Tooltip, Typography} from "antd";
import {useParams} from "react-router-dom";
import {useApiSearchAdminPollQuestionSurveyIdResult} from "@/api/question";
import toFaNumber from "@/lib/utils/number";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {PrinterIcon} from "lucide-react";
import {useReactToPrint} from "react-to-print";

const {Text} = Typography;

function QuestionWithTextResultSurveySection() {
    const param = useParams()
    const survey_id = param.id;
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({contentRef});


    const {data, isPending: isPendingGet, refetch, isRefetching} = useApiSearchAdminPollQuestionSurveyIdResult({
        survey_id: survey_id,
        question_type: 'text',
        page: currentPage,
        per_page: pageSize
    });

    const renderQuestionAnswers = (question) => {
        if (!question.answer_details || question.answer_details.length === 0) {
            return (
                <div className=" text-center py-4">
                    هنوز پاسخی ثبت نشده است
                </div>
            );
        }

        return (
            <Collapse accordion>
                <Collapse.Panel header={question.title} key={question.id}>
                    <List
                        dataSource={question.answer_details}
                        renderItem={(answer, index) => (
                            <List.Item>
                                <Card className="w-full">
                                    <div className="flex justify-between items-start">
                                        <div className="flex-1">
                                            <div className="flex items-start gap-2">
                                                <div className="px-2 py-1 rounded text-sm">
                                                    {toFaNumber(index + 1)}
                                                </div>
                                                <Text className="whitespace-pre-wrap">
                                                    {answer.answer}
                                                </Text>
                                            </div>
                                        </div>

                                        <div className="text-sm  mr-4">
                                            {convertToJalaliWithFormat(answer.created_at)}
                                        </div>
                                    </div>
                                </Card>
                            </List.Item>
                        )}
                    />
                </Collapse.Panel>
            </Collapse>
        );
    };

    if (isPendingGet) {
        return <Skeleton active/>;
    }

    return (
        <>
            <Button
                style={{width: '50px'}}
                className="mb-4 absolute left-2 mt-4"

                onClick={reactToPrintFn}>
                <PrinterIcon/>
            </Button>
            <div ref={contentRef}>
                {data?.data?.data?.length <= 0 && <Empty description={'داده‌ای یافت نشد'}/>}

                <div className="space-y-6">
                    {data?.data?.data?.map((question) => (
                        <div key={question.id} className="p-6 rounded-lg shadow">
                            <div className="flex justify-between items-start mb-4">
                                <div>
                                    <h3 className="text-lg font-semibold mb-2">
                                        {question.title}
                                        {question.required ? (
                                            <span className="ml-2 text-xs mx-2 text-red-500">(الزامی)</span>
                                        ) : ''}
                                        {question.for_teacher ? (

                                            <Tooltip
                                                title={'این سوال به ازای همه اساتیدی که در دریافت این گواهی نامه برای پرونده فراگیر ثبت شده است تکرار شده'}>
                                            <span className="ml-2 text-xs mx-2 ">
                                        (سوال از استاد)
                                                </span>
                                            </Tooltip>

                                        ) : ''}
                                    </h3>
                                    {question.description && (
                                        <p className="text-gray-600 mb-4">{question.description}</p>
                                    )}
                                </div>
                                <div className="text-sm ">
                                    تعداد پاسخ‌ها:
                                    <span
                                        className={'font-bold mx-2 text-blue-600'}>{toFaNumber(question.answer_details_count)}</span>
                                </div>
                            </div>

                            <Divider className="my-4"/>

                            {renderQuestionAnswers(question)}
                        </div>
                    ))}

                    {/*{data?.meta && (*/}
                    {/*    <div className="flex justify-center mt-6">*/}
                    {/*        <Pagination*/}
                    {/*            current={currentPage}*/}
                    {/*            pageSize={pageSize}*/}
                    {/*            total={data.meta.total}*/}
                    {/*            onChange={(page, pageSize) => {*/}
                    {/*                setCurrentPage(page);*/}
                    {/*                setPageSize(pageSize);*/}
                    {/*            }}*/}
                    {/*            showSizeChanger*/}
                    {/*            showTotal={(total, range) => `${range[0]}-${range[1]} از ${total} سوال`}*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*)}*/}
                </div>
            </div>
        </>
    );
}

export default QuestionWithTextResultSurveySection;


